import {
    ADDMERCHANTCHARGE_SUCCESS,
    ADDMERCHANTCHARGE_FAILED,
    RESET_ADDMERCHANTCHARGE,
    LOADING_ADDMERCHANTCHARGE,
    NETWORK_ERROR_ADDMERCHANTCHARGE
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetAddMerchantCharge = () => {
    return { type: RESET_ADDMERCHANTCHARGE };
};

const addMerchantCharge = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_ADDMERCHANTCHARGE });
    await partnerServices
        .post("addNewMerchantCharges", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(addMerchantChargesuccess(res.data));
                    break;
                default:
                    dispatch(addMerchantChargeFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_ADDMERCHANTCHARGE,
                payload: err
            });
        });
};
function addMerchantChargesuccess(data) {
    return {
        type: ADDMERCHANTCHARGE_SUCCESS,
        payload: data
    };
}
function addMerchantChargeFailed(data) {
    return {
        type: ADDMERCHANTCHARGE_FAILED,
        payload: data
    };
}

export { resetAddMerchantCharge, addMerchantCharge };
